import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";

import { isPwa } from "helpers/pwa_utils";
import { log } from "helpers/pwa_logger";

export default class extends Controller {
  static values = {
    isPwaOverride: Boolean,
    isPwaSession: Boolean,
    path: String,
  };

  async connect() {
    log("session_upgrade_controller connected");

    if ((await this.#isPwa()) && !this.isPwaSessionValue) {
      log("Detected PWA mode without a PWA session. Upgrading session...");

      try {
        // Call the endpoint to upgrade the session
        const response = await post(this.pathValue, { responseKind: "json" });
        if (response.ok) {
          log("Successfully upgraded to PWA session");
          // the cookie is now set via the server side response
        } else {
          log("Failed to upgrade to PWA session:", response.statusText);
        }
      } catch (error) {
        log("Error upgrading to PWA session:", error);
      }
    }
  }

  // Wrapper for `isPwa` to allow changing the value in the test env
  // TODO: Set up real installed-app tests so we don't have to do this hacky override stuff
  async #isPwa() {
    let isPwaMode = await isPwa(); // Always run the standard detection
    if (this.isPwaOverrideValue) {
      return true;
    } else {
      return isPwaMode;
    }
  }
}
